module.exports = __webpack_public_path__ + "assets/img/logo.c8a792ca.svg";